import request from './request'
import type {
  ApplyWithdrawRequest,
  PageVO,
  PointRecordItem,
  TopicListItem,
  UpdateProfileRequest,
  UserActivityItem,
  UserContentStats,
  UserInfo,
  WalletInfo,
  WithdrawItem,
  WithdrawQuota,
} from '@/types/api'

export const userApi = {
  me() {
    return request.get<unknown, UserInfo>('/api/web/user/me')
  },
  updateProfile(data: UpdateProfileRequest) {
    return request.patch<unknown, UserInfo>('/api/web/user/me', data)
  },
  myStats() {
    return request.get<unknown, UserContentStats>('/api/web/user/me/stats')
  },
  myActivities(limit = 10) {
    return request.get<unknown, PageVO<UserActivityItem>>('/api/web/user/me/activities', {
      params: { limit },
    })
  },
  myPoints(page = 1, size = 10) {
    return request.get<unknown, PageVO<PointRecordItem>>('/api/web/user/me/points', {
      params: { page, size },
    })
  },
  myTopics(page = 1, size = 10) {
    return request.get<unknown, PageVO<TopicListItem>>('/api/web/user/me/topics', {
      params: { page, size },
    })
  },
  myWallet() {
    return request.get<unknown, WalletInfo>('/api/web/user/me/wallet')
  },
  myWithdraws(page = 1, size = 10) {
    return request.get<unknown, PageVO<WithdrawItem>>('/api/web/user/me/withdraws', {
      params: { page, size },
    })
  },

  /**
   * 提现预检：限额、费率、本月剩余次数、最大可提金额。
   *
   * 申请弹窗打开时调。拿 feeRate 在前端实时算账 ——
   * 手续费在提现金额【之外】另扣（老站口径），用户自己算不清。
   */
  withdrawQuota() {
    return request.get<unknown, WithdrawQuota>('/api/web/user/me/withdraw-quota')
  },

  /**
   * 提交提现申请，返回新建记录 id。
   *
   * 后端会重新校验一遍金额/在途/次数 —— 前端校验是体验，后端校验是底线。
   */
  applyWithdraw(data: ApplyWithdrawRequest) {
    return request.post<unknown, number>('/api/web/user/me/withdraws', data)
  },
}
